// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const RefreshAutoIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="RefreshAutoIcon" ref={forwardedRef} {...props}>
      <path d="M17.05 4.252v1.871a8.046 8.046 0 0 0-12.7-1.78A7.96 7.96 0 0 0 2.049 9.12a7.97 7.97 0 0 0 2.303 6.538 8.03 8.03 0 0 0 6.56 2.295 8 8 0 0 0 4.791-2.295 7.96 7.96 0 0 0 2.316-4.905h-1.51a6.47 6.47 0 0 1-1.868 3.846 6.5 6.5 0 0 1-3.894 1.865 6.52 6.52 0 0 1-5.333-1.865 6.48 6.48 0 0 1-1.871-5.315 6.46 6.46 0 0 1 1.871-3.881 6.54 6.54 0 0 1 10.43 1.65H14.25v1.2h4v-4z" />
      <path d="M8.5 7H10v3.5h2.5V12h-4z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const RefreshAutoIcon = /* @__PURE__ */ Object.assign(
  RefreshAutoIconComponent,
  { displayName: 'RefreshAutoIcon' },
);
